import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Checkbox, IconButton, Typography } from "@mui/material";
import clsx from "clsx";
import { useState, useEffect } from "react";

function Table({
  data,
  fields,
  checked,
  setChecked,
  setSortColumns,
  sortColumns,
}) {
  const [isAllChecked, setIsAllChecked] = useState(false);

  const onCheckedClickHandler = (id) => {
    setChecked({ ...checked, [id]: !checked[id] });
  };

  // if select all clicked, change vlaue of all checkboxes
  useEffect(() => {
    const obj = {};
    data.forEach((item) => {
      obj[item.id] = isAllChecked;
    });
    setChecked(obj);
  }, [isAllChecked, setChecked, data]);

  const checkedCount = Object.values(checked).filter((value) => value).length;
  return (
    <div
      style={{
        maxHeight: "calc(100vh - 250px)",
        maxWidth: "calc(100vw - 200px)",
      }}
      className="relative mt-4 overflow-auto overflow-x-auto"
    >
      <table className="w-full text-left text-sm ">
        <thead className="border-b-2 border-gray-200 text-xs capitalize sticky top-0 bg-white z-10">
          <tr>
            <th className="px-6 py-3 sticky left-0 bg-white z-20">
              <div className="flex items-center gap-1">
                <Checkbox
                  checked={isAllChecked}
                  onClick={() => setIsAllChecked(!isAllChecked)}
                />
                <Typography className="font-medium">
                  {checkedCount > 0 && "(" + checkedCount + ")"}
                </Typography>
              </div>
            </th>
            {fields.map((field, id) => (
              <th key={id} scope="col" className="px-6 py-3">
                <div className="flex items-center gap-1">
                  <Typography className="font-medium">
                    {field.columnName}
                  </Typography>
                  {((field.field && !sortColumns[field.field]) ||
                    sortColumns[field.field] === "ASC") && (
                    <IconButton
                      onClick={() =>
                        setSortColumns({
                          [field.field]: "DESC",
                        })
                      }
                    >
                      <KeyboardArrowDown />
                    </IconButton>
                  )}
                  {field.field && sortColumns[field.field] === "DESC" && (
                    <IconButton
                      onClick={() =>
                        setSortColumns({
                          [field.field]: "ASC",
                        })
                      }
                    >
                      <KeyboardArrowUp />
                    </IconButton>
                  )}
                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data.map((item, id) => (
            <tr
              key={id}
              className={clsx(
                "border-b bg-white",
                id === data.length - 1 && "border-b-2 border-gray-200"
              )}
            >
              <td>
                <Checkbox
                  sx={{
                    opacity: checked[item.id] ? 1 : 0.5,
                  }}
                  checked={checked[item.id] || false}
                  onClick={() => onCheckedClickHandler(item.id)}
                />
              </td>
              {fields.map((field, id1) => (
                <td key={id1} className="max-w-80 truncate px-6 py-4">
                  {field.render(item)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table;
/* styles.css or tailwind classes */
